import { useNavigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Modal, ModalWrapper, Button } from '~ui-kit';
import { mediumGap } from '~theme';

const green = '#1d863f';

const ExternalSystemModal = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const onHide = () => navigate(-1);

  return (
    <Modal show onHide={onHide}>
      <ModalWrapper
        title={`${
          state.formTitle ? 'Lomake' : 'Linkki'
        } aukeaa uuteen ikkunaan`}
        close={onHide}
      >
        {state.formTitle ? (
          <>
            <p>
              Lomake &ldquo;<strong>{state?.formTitle}</strong>&rdquo; täytetään
              Paketin ulkopuolella olevalla sivulla, minkä vuoksi se aukeaa
              selaimessa uuteen ikkunaan.
            </p>
            <p>
              Huom! Paketin ulkopuolella tehty tilaus{' '}
              <strong>
                ei näy Paketin tilauslistassa eikä siitä tule
                sähköpostivarmistusta.
              </strong>
            </p>
            <p>
              Seuraa ulkoisia tilauksia{' '}
              <a
                href={state?.externalTrackingUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                järjestelmän omalla tilauslistalla.
              </a>
            </p>
          </>
        ) : (
          <p>
            Linkki vie ulkoiselle sivustolle:{' '}
            <a href={state?.externalUrl} target="_blank" rel="noreferrer">
              {state?.externalUrl}
            </a>
          </p>
        )}
        <ButtonWrapper>
          <Button cancel onClick={() => navigate(-1)}>
            Peruuta
          </Button>
          <Button
            bgColor={green}
            onClick={() => {
              window.open(state.externalUrl, '_blank').focus();
              onHide();
            }}
          >
            {state.formTitle ? 'Avaa ulkoinen lomake' : 'Avaa ulkoinen sivusto'}
          </Button>
        </ButtonWrapper>
      </ModalWrapper>
    </Modal>
  );
};

const ButtonWrapper = styled.span`
  display: flex;
  gap: ${mediumGap};
  justify-content: space-between;
  padding-top: 24px;

  > * {
    flex: 1;
  }
`;

export default ExternalSystemModal;
